import { useEffect, useMemo } from 'react';
import { checkAllObjectValuesNull } from '@/shared/lib';
import { useGetDocumentsQuery } from '@/entities/documents';
import { setLegalDocuments, useAppDispatch } from '@/app/store';

export const useActualiseDocuments = () => {
  const dispatch = useAppDispatch();
  const { data } = useGetDocumentsQuery();
  const legalDocuments = useMemo(() => data?.data, [data?.data]);

  useEffect(() => {
    if (legalDocuments && !checkAllObjectValuesNull(legalDocuments)) dispatch(setLegalDocuments(legalDocuments));
  }, [dispatch, legalDocuments]);
};
